export default function StatusBadge({ status }) {
  const map = {
    PENDIENTE: "bg-amber-50 text-amber-700 border-amber-200",
    APROBADO: "bg-blue-50 text-blue-700 border-blue-200",
    TRANSFERIDO: "bg-indigo-50 text-indigo-700 border-indigo-200",
    LIQUIDADO: "bg-emerald-50 text-emerald-700 border-emerald-200",
    RECHAZADO: "bg-rose-50 text-rose-700 border-rose-200",
    RECIBIDA: "bg-emerald-50 text-emerald-700 border-emerald-200",
    ACTIVA: "bg-emerald-50 text-emerald-700 border-emerald-200",
    INACTIVA: "bg-slate-100 text-slate-600 border-slate-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 border px-2.5 py-0.5 rounded-full text-[11px] font-semibold tracking-wide uppercase ${cls}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
